import { IconBaseProps } from "react-icons";

export function AssignCheckIcon(props: IconBaseProps) {
  const { size = 24, color = "currentColor", ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 0.5C13.19 0.5 14.24 1.094 14.872 2H21.5V22H2.5V2H9.128C9.45038 1.53702 9.8799 1.15882 10.38 0.897647C10.88 0.636469 11.4358 0.500045 12 0.5ZM10.586 16.657L17.657 9.586L16.243 8.172L10.586 13.828L7.758 11L6.344 12.414L10.586 16.657Z"
        fill={color}
      />
    </svg>
  );
}
